import React from "react";
import _ from 'lodash';
import {cssInfoList} from 'module/PersonInfo/style/InfoListStyle';

interface Props {
	models: string[]
}

export function PersonInfoList({models}: Props) {
	return (
		<div className={'PersonInfoList'} css={cssInfoList.root}>
			{
				_.map(models, (msg, i) => (
					<div key={i} css={cssInfoList.msg} dangerouslySetInnerHTML={{__html: msg}}/>
				))
			}
		</div>
	)
}
